import { render, staticRenderFns } from "./columndetail.vue?vue&type=template&id=b7a99972&scoped=true&"
import script from "./columndetail.vue?vue&type=script&lang=js&"
export * from "./columndetail.vue?vue&type=script&lang=js&"
import style0 from "./columndetail.vue?vue&type=style&index=0&id=b7a99972&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a99972",
  null
  
)

component.options.__file = "columndetail.vue"
export default component.exports